export default "__VITE_ASSET__BEWY3lkX__"